module.exports = __RENDER_8_COMPONENTS__['vtex.css-handles@1.x/useCssHandles'];